module.exports = __webpack_public_path__ + "static/img/cloud19.a12c8fa6.png";